import { UserType } from './user';
import { CommonFieldType } from './utils';

export type UserLevelPrice = CommonFieldType & {
  userLevelId: string;
  productId: string;

  // source
  buySourcePrice: PriceSource;
  sellSourcePrice: PriceSource;

  // profit
  buyProfit: number;
  sellProfit: number;

  updatedBy?: string;
  updatedByUser?: UserType;
};

export enum PriceSource {
  ASSOCIATION = 'สมาคม',
  HSH = 'ออนไลน์', // ตอนนี้คือ GCAP
  CUSTOM = 'กำหนดเอง',
}
